import type { StorageReference } from 'firebase/storage';
import { uploadBytes } from 'firebase/storage';

const IMMUTABLE_IMAGE_CACHE_CONTROL = 'public, max-age=31536000, immutable';

export function uploadImage(storageRef: StorageReference, image: Blob | Uint8Array | ArrayBuffer) {
  const contentType = image instanceof Blob && image.type ? image.type : undefined;

  return uploadBytes(storageRef, image, {
    cacheControl: IMMUTABLE_IMAGE_CACHE_CONTROL,
    ...(contentType && { contentType }),
  });
}
